import { useFormikContext } from 'formik';
import CurrencyField from 'src/components/util/CurrencyField';

export default function MotorVehiclePropertyValueAndTaxInfo() {
  const form = useFormikContext();

  const handleFieldChange = (field, val) => {
    form.setFieldValue(field, val);
  };

  return (
    <div className="flex flex-col gap-4">
      <div className="flex flex-col gap-2 sm:flex-row sm:justify-between xl:justify-start">
        <CurrencyField
          label="Total Paid"
          name="valueAndTaxInfo.amountPaid"
          onChange={handleFieldChange}
        />
      </div>
      <div className="flex flex-col gap-2 sm:flex-row sm:justify-between xl:justify-start">
        <CurrencyField
          label="Amount Owner Offers in Settlement"
          name="valueAndTaxInfo.amountOfferedInSettlement"
          onChange={handleFieldChange}
        />
      </div>
      <div className="flex flex-col gap-2 sm:flex-row sm:justify-between xl:justify-start">
        <CurrencyField
          label="Amount to be abated/refunded"
          name="valueAndTaxInfo.amountToBeRefunded"
          onChange={handleFieldChange}
        />
      </div>
    </div>
  );
}
